import { IconButton, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import { PRODUCT_SEARCH_HINT } from '../../utils/productSearch';

/**
 * Campo padrão de busca de produto.
 * Não dispara a busca a cada tecla: Enter ou o botão Buscar do formulário.
 * Espaço no início significa "contém"; sem espaço, a API exige correspondência exata.
 */
export default function BuscaProdutoCampo({
  value,
  onChange,
  onSearch,
  sx,
  fullWidth = false,
  autoFocus = false,
}) {
  return (
    <TextField
      placeholder={PRODUCT_SEARCH_HINT}
      variant="outlined"
      size="small"
      fullWidth={fullWidth}
      autoFocus={autoFocus}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      onKeyDown={(e) => {
        if (e.key !== 'Enter') return;
        e.preventDefault();
        onSearch?.();
      }}
      InputProps={{
        startAdornment: <SearchIcon sx={{ mr: 1, color: 'text.secondary' }} />,
        endAdornment: value ? (
          <IconButton
            size="small"
            aria-label="Limpar busca"
            onClick={() => onChange('')}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        ) : null,
      }}
      sx={{ flex: fullWidth ? undefined : 2, minWidth: fullWidth ? undefined : 260, ...sx }}
    />
  );
}
